<script lang="ts">
	import type { PageData } from './$types';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import DatasheetPanel from '$lib/components/pois/datasheet/DatasheetPanel.svelte';
	import { isDatasheetPoiData } from '$lib/components/pois/utils';
	import { ROUTE_SEARCH } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import { onMount } from 'svelte';

	const { moveDrawer } = getMapLayoutContext();

	export let data: PageData;
	$: ({ poisStore } = data);
	$: ({ selectedPoiData } = $poisStore);

	const searchParams = getSearchParamsStore();

	onMount(() => {
		// 272px is the height of the datasheet when the drawer is partially open
		setTimeout(() => moveDrawer(272), 0);
	});
</script>

<!-- TODO: Replace this if statement with a proper route guard in page.ts -->
{#if selectedPoiData && isDatasheetPoiData(selectedPoiData)}
	<DatasheetPanel
		poi={selectedPoiData}
		onClose={() => {
			gotoWithParams(ROUTE_SEARCH, { ...$searchParams, selectedPoi: undefined });
		}}
	/>
{/if}
